/**
 * Who asked for a Denker window or page. Only the person's own open (a click,
 * a shortcut, a menu) takes the keyboard; a page an agent opens, or Denker
 * opens by itself, shows without taking it from what the person is typing in.
 * The Rust `restore_desktop_window` reads the same two values.
 */
export type WindowOpener = "user" | "denker";

/** An opener from an event payload: anything but the person's is Denker's. */
export function windowOpenerFrom(value: unknown): WindowOpener {
  return value === "user" ? "user" : "denker";
}

/** A page the person opened stays theirs when Denker navigates it. */
export function combinedOpener(
  current: WindowOpener,
  next: WindowOpener,
): WindowOpener {
  return current === "user" || next === "user" ? "user" : "denker";
}
